import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6232d715"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clubProductListPage" }
const _hoisted_2 = { class: "club-products-block" }
const _hoisted_3 = { class: "show-all-products-div" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderTitleWithSearch = _resolveComponent("HeaderTitleWithSearch")!
  const _component_ProductCard = _resolveComponent("ProductCard")!
  const _component_BackAndCancelFooter = _resolveComponent("BackAndCancelFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderTitleWithSearch, {
      title: 'Club Name Products',
      rows: [],
      onOnSelect: _ctx.onSelectProduct,
      onChangeSearchText: _ctx.changeSearchText
    }, null, 8, ["onOnSelect", "onChangeSearchText"]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsView, (product) => {
          return (_openBlock(), _createBlock(_component_ProductCard, {
            product: product,
            key: product.id,
            highlighted: _ctx.orderProducts.some((x) => x == product.id)
          }, null, 8, ["product", "highlighted"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAll = !_ctx.showAll))
        }, _toDisplayString(_ctx.showAll
              ? _ctx.$t("cashier.btn.hide-rest-products")
              : _ctx.$t("cashier.btn.show-rest-products")), 1)
      ])
    ]),
    _createVNode(_component_BackAndCancelFooter)
  ]))
}